import type { MiniAppManifest, MiniAppShellConfig, MiniAppShellRailConfig } from './types';

/**
 * Resolve /tools/<slug> from a pathname, or null when not inside a tool route.
 * Case-insensitive and lowercased: react-router matches routes without regard
 * to case, so `/tools/Delphi` renders Delphi and must resolve to its slug.
 */
export function toolsSlugFromPathname(pathname: string): string | null {
  const match = pathname.match(/^\/tools\/([^/]+)/i);
  return match?.[1]?.toLowerCase() ?? null;
}

/** Full shell config for the mini-app currently mounted under /tools/<slug>. */
export function resolveShellConfig(
  pathname: string,
  manifests: MiniAppManifest[],
): MiniAppShellConfig | undefined {
  const slug = toolsSlugFromPathname(pathname);
  if (!slug) return undefined;
  return manifests.find((m) => m.slug === slug)?.shell;
}

/** Shell rail config for the mini-app currently mounted under /tools/<slug>. */
export function resolveShellRailConfig(
  pathname: string,
  manifests: MiniAppManifest[],
): MiniAppShellRailConfig | undefined {
  return resolveShellConfig(pathname, manifests)?.rail;
}
